import { render, staticRenderFns } from "./tableSetting.vue?vue&type=template&id=76a204b5&scoped=true"
import script from "./tableSetting.vue?vue&type=script&lang=js"
export * from "./tableSetting.vue?vue&type=script&lang=js"
import style0 from "./tableSetting.vue?vue&type=style&index=0&id=76a204b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a204b5",
  null
  
)

export default component.exports